<app-evidence-requirements-modal
    [productLicenseId]="productLicenseId"
    [exactEvidenceId]="exactEvidenceId"
    [initialItemAction]="initialItemAction"
    [expectedMerchantId]="expectedMerchantId"
    [canOpenEvidenceUpload]="!!assessmentContext"
    [visible]="modalVisible"
    [emailSending]="emailSending"
    [emailSuccessMessage]="emailSuccessMessage"
    [emailFailureMessage]="emailFailureMessage"
    (visibleChange)="onVisibleChange($event)"
    (emailRequested)="onEmailRequested($event)"
    (emailStatusCleared)="clearEmailStatus()"
    (linkedFileRequested)="onLinkedFileRequested($event)"
    (uploadRequested)="onUploadRequested($event)"
></app-evidence-requirements-modal>
